function numericSpinner() {
  function link($scope, element, attrs, ctrl) {
    const ngModelCtrl = ctrl;
    const scope = $scope;
    ngModelCtrl.$isEmpty = (value) => !value;

    scope.decrease = () => {
      scope.value = scope.value || scope.negative ? scope.value - 1 : 0;
      if (scope.skipZero && !scope.value) scope.value = -1;
    };

    scope.increase = () => {
      scope.value = scope.value ? scope.value + 1 : 1;
      if (scope.skipZero && !scope.value) scope.value = 1;
    };

    scope.check = () => {
      scope.value = parseInt(
        scope.value.replace(scope.negative ? /[^\W\d]/ : /[^\d]/, ''),
        10
      );
    };

    const setElementValidity = () => {
      ngModelCtrl.$setValidity(
        'value',
        scope.negative ? true : scope.value >= 0
      );
    };

    scope.$watch('value', () => {
      setElementValidity();
      ngModelCtrl.$validate();
      ngModelCtrl.$setDirty();
    });
  }

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      value: '=ngModel',
      disabled: '=ngDisabled',
      negative: '=',
      skipZero: '='
    },
    template:
      "<div class='input-group spinner' ng-class='{disabled: disabled}'><input type='text' class='form-control' ng-change='check()' ng-model='value' ng-disabled='disabled'><div class='input-group-btn-vertical'><button class='btn btn-default btn-legacy' type='button' ng-click='increase()' data-testid='numericSpinnerIncrease' ng-disabled='disabled'><i class='fa fa-caret-up'></i></button><button class='btn btn-default btn-legacy' type='button' ng-disabled='disabled' ng-click='decrease()'><i class='fa fa-caret-down'></i></button></div></div>",
    link
  };
}

const directiveArr = [numericSpinner];

export default function (ngModule) {
  ngModule.directive('numericSpinner', directiveArr);
}
